import { IntlShape } from 'react-intl';
import { HistoricalDataItemGroup } from '../../../services/historicalData';
import { ICounter } from '../../Devices/Counter';
import { CounterMedium } from '../../Devices/CounterMedium';
import { defaultDataSet } from './defaultOptions';
import { addMinutes, startOfMonth } from 'date-fns';
import { y } from '@fullcalendar/core/internal-common';


export function datasetFromData(data: ITypeAndData, intl: IntlShape) {
    const timezoneOffset = (new Date()).getTimezoneOffset(); // timezones like Bogota -5 aree wrong without the correction
    return {

        ...defaultDataSet,
        label: data?.lable,
        data: data?.data.map((item) => { return { x: startOfMonth(addMinutes(new Date(item.timeStamp),timezoneOffset)), y: item.avgValue }}),
        backgroundColor: data?.color, 
        fill : false,
        borderColor: data?.color, 
        y: data?.y
    }
}


export interface ITypeAndData {
    color: string
    lable: string
    y: string
    data: HistoricalDataItemGroup[]
}


